<template>
	<div class="contentbox">
		<div class="media-add-video-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="剧目ID" prop="albumId">
						<el-input v-model="formInline.albumId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="短剧标题" prop="title">
						<el-input v-model="formInline.title" placeholder="请输入短剧标题" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="审核状态" prop="isVerify" style="margin-right: 30px;">
						<el-select v-model="formInline.isVerify" placeholder="请选择审核状态" clearable @change="search" style="width: 150px;">
							<el-option
									v-for="item in isVerifyOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="视频上线状态" prop="rackStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.rackStatus" placeholder="请选择上线状态" clearable @change="search" style="width: 150px;">
							<el-option
									v-for="item in rackStatusOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-has="'mediaAddVideo:add'" type="success" icon="el-icon-circle-plus-outline"  @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="" label="序号" width="60" fixed>
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="albumId" label="剧目ID">
					</el-table-column>
					<el-table-column prop="isVerify" label="短剧审核状态" align="center" width="105">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.isVerify == 0" type="primary" effect="dark">未审核</el-tag>
							<el-tag v-if="scope.row.isVerify == 1" type="warning" effect="dark">审核中</el-tag>
							<el-tag v-if="scope.row.isVerify == 2" type="success" effect="dark">已审核</el-tag>
							<el-tag v-if="scope.row.isVerify == 3" type="danger" effect="dark">审核不通过</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="statusOnline" label="短剧上线状态" align="center" width="105">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.rackStatus == 0" type="primary" effect="dark">未上线</el-tag>
							<el-tag v-if="scope.row.rackStatus == 1" type="success" effect="dark">已上线</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="appidName" label="小程序" width="110">
					</el-table-column>
					<el-table-column label="短剧信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>短剧名称：{{scope.row.title}}</p>
								<p>总集数：{{scope.row.sumEps}}</p>
								<p>发行年份：{{scope.row.issueYear}}</p>
								<p>短剧更新状态：
									<span v-if="scope.row.videoUpdateStatus == 0" class="primary-text">未完结</span>
									<span v-if="scope.row.videoUpdateStatus == 1" class="succes-text">已完结</span>
								</p>
								<p>资质状态：
									<span class="primary-text" v-if="scope.row.qualifiedStatus == 1">未报审</span>
									<span class="succes-text" v-if="scope.row.qualifiedStatus == 2">报审通过</span>
									<span class="danger-text" v-if="scope.row.qualifiedStatus == 3">报审不通过</span>
									<span class="warnning-text" v-if="scope.row.qualifiedStatus == 4">不建议报审</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="剧审核反馈">
                        <template slot-scope="scope">
                            <el-tooltip placement="top" v-if="scope.row.verifyMsg">
                                <div slot="content">{{scope.row.verifyMsg}}</div>
                                <div class="td-info line3">{{scope.row.verifyMsg}}</div>
                            </el-tooltip>
                        </template>
					</el-table-column>
					<el-table-column prop="videoAbility" label="剧能力列表">
					</el-table-column>
					<el-table-column prop="verifyNumber" label="剧审核次数" width="100">
					</el-table-column>
					<el-table-column prop="delayVerify" label="后置审核状态" width="110">
					</el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row.id)">详情</el-button>
							<el-button v-has="'mediaAddVideo:update'" type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover v-has="'mediaAddVideo:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<el-dropdown v-has="'mediaAddVideo:more'" trigger="click" style="margin-left: 10px;">
								<el-button type="success" size="mini">
									更多<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown" @command="handleCommand">
									<el-dropdown-item command="createVideo" :disabled="scope.row.processNumber != 1" @click.native="handleCreateVideo(scope.row.id)">创建短剧</el-dropdown-item>
									<el-dropdown-item command="addVid" :disabled="scope.row.processNumber != 2" @click.native="handleAddVid(scope.row.id)">一键填充VID</el-dropdown-item>
									<el-dropdown-item command="addVideo" :disabled="scope.row.processNumber != 3" @click.native="handleAddVideo(scope.row.id)">一键上传视频</el-dropdown-item>
									<el-dropdown-item command="addEpisodeId" :disabled="scope.row.processNumber != 4" @click.native="handleAddEpisodeId(scope.row.id)">编辑短剧</el-dropdown-item>
									<el-dropdown-item command="addVideoAuth" @click.native="handleAddVideoAuth(scope.row.id)">短剧授权</el-dropdown-item>
									<el-dropdown-item command="submitReview" :disabled="scope.row.processNumber != 5" @click.native="handleSubmitReview(scope.row.id)">短剧送审</el-dropdown-item>
									<el-dropdown-item command="getVerifyStatus" @click.native="handleGetVerifyStatus(scope.row.id)">审核查询</el-dropdown-item>
									<el-dropdown-item command="upOrDownVideo" :disabled="scope.row.processNumber != 7" @click.native="handleUpOrDownVideo(scope.row.id, scope.row.rackStatus == 0 ? 1 : 0)">
                                        {{scope.row.rackStatus == 0 ? '短剧上线' : '短剧下线'}}
                                    </el-dropdown-item>
								</el-dropdown-menu>
								<!--<el-dropdown-menu slot="dropdown">-->
									<!--<el-dropdown-item command="createVideo" :disabled="scope.row.createStatus == 1" @click.native="handleCommand('createVideo', scope.row.id)">创建短剧</el-dropdown-item>-->
									<!--<el-dropdown-item command="addVideo" @click.native="handleCommand('addVideo', scope.row.id)">一键上传视频</el-dropdown-item>-->
									<!--<el-dropdown-item>短剧编辑</el-dropdown-item>-->
									<!--<el-dropdown-item command="submitReview" :disabled="scope.row.isVerify != 2" @click.native="handleCommand('submitReview', scope.row.id)">短剧送审</el-dropdown-item>-->
									<!--<el-dropdown-item command="upOrDownVideo" :disabled="scope.row.isVerify != 2" @click.native="handleCommand('upOrDownVideo', scope.row.id)">短剧上线</el-dropdown-item>-->
									<!--<el-dropdown-item command="getVerifyStatus" @click.native="handleCommand('getVerifyStatus', scope.row.id)">审核查询</el-dropdown-item>-->
									<!--<el-dropdown-item>后置审核查询</el-dropdown-item>-->
									<!--<el-dropdown-item command="addVid" :disabled="scope.row.isVerify == 2" @click.native="handleCommand('addVid', scope.row.id)">一键填充VID</el-dropdown-item>-->
								<!--</el-dropdown-menu>-->
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">短剧ID</td>
						<td>{{ruleForm.albumId}}</td>
					</tr>
					<tr>
						<td>短剧审核状态</td>
						<td>
							<el-tag v-if="ruleForm.isVerify == 0" type="primary" effect="dark">未审核</el-tag>
							<el-tag v-if="ruleForm.isVerify == 1" type="warning" effect="dark">审核中</el-tag>
							<el-tag v-if="ruleForm.isVerify == 2" type="success" effect="dark">已审核</el-tag>
							<el-tag v-if="ruleForm.isVerify == 3" type="danger" effect="dark">审核不通过</el-tag>
						</td>
					</tr>
					<tr>
						<td>短剧上线状态</td>
						<td>
							<el-tag v-if="ruleForm.rackStatus == 1" type="success" effect="dark">已上线</el-tag>
							<el-tag v-if="ruleForm.rackStatus == 0" type="primary" effect="dark">未上线</el-tag>
						</td>
					</tr>
					<tr>
						<td>小程序</td>
						<td>{{ruleForm.appidName}}</td>
					</tr>
					<tr>
						<td>短剧信息</td>
						<td>
							<table class="el-table el-table--border mytable" cellspacing="0" cellpadding="0">
								<tbody>
									<tr>
										<td width="150">短剧标题</td>
										<td>{{ruleForm.title}}</td>
									</tr>
									<tr>
										<td>总集数</td>
										<td>{{ruleForm.sumEps}}</td>
									</tr>
									<tr>
										<td>发行年份</td>
										<td>{{ruleForm.issueYear}}</td>
									</tr>
									<tr>
										<td>短剧更新状态</td>
										<td>
											<span v-if="ruleForm.videoUpdateStatus == 1" class="succes-text">已完结</span>
											<span v-if="ruleForm.videoUpdateStatus == 0" class="primary-text">未完结</span>
										</td>
									</tr>
									<tr>
										<td>资质状态</td>
										<td>
											<span class="primary-text" v-if="ruleForm.qualifiedStatus == 1">未报审</span>
											<span class="succes-text" v-if="ruleForm.qualifiedStatus == 2">报审通过</span>
											<span class="danger-text" v-if="ruleForm.qualifiedStatus == 3">报审不通过</span>
											<span class="warnning-text" v-if="ruleForm.qualifiedStatus == 4">不建议报审</span>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
					<tr>
						<td>剧审核反馈</td>
						<td>{{ruleForm.verifyMsg}}</td>
					</tr>
					<tr>
						<td>剧能力列表</td>
						<td>{{ruleForm.videoAbility}}</td>
					</tr>
					<tr>
						<td>剧审核次数</td>
						<td>{{ruleForm.verifyNumber}}</td>
					</tr>
					<tr>
						<td>后置审核状态</td>
						<td>{{ruleForm.delayVerify}}</td>
					</tr>
					<!--<tr>-->
						<!--<td>短剧图片&标题&简介审核</td>-->
						<!--<td></td>-->
					<!--</tr>-->
					<!--<tr>-->
						<!--<td>path重定向校验</td>-->
						<!--<td></td>-->
					<!--</tr>-->
					<!--<tr>-->
						<!--<td>path绑定校验</td>-->
						<!--<td></td>-->
					<!--</tr>-->
					<!--<tr>-->
						<!--<td>path跳转异常校验</td>-->
						<!--<td></td>-->
					<!--</tr>-->
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350"  size="small" style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<!--<el-form-item label="选择小程序：" prop="appidName">-->
					<!--<span>{{ruleForm.appidName}}</span>-->
				<!--</el-form-item>-->
				<!--<el-form-item label="选择小程序：" prop="appid">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appid"></app-list>-->
				<!--</el-form-item>-->
				<el-form-item label="选择小程序：" prop="appid">
					<el-tag closable @close="handleCloseTagApp" v-if="ruleForm.appidName" style="margin-right: 10px;">{{ruleForm.appidName}}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogApp = true">选择</el-button>
					<el-input v-model="ruleForm.appid" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="短剧名称：" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入短剧名称"></el-input>
				</el-form-item>
				<el-form-item label="总集数：" prop="sumEps">
					<el-input type="number" v-model="ruleForm.sumEps" placeholder="请输入总集数"></el-input>
				</el-form-item>
				<el-form-item label="封面图：" prop="picUrl">
					<el-upload
							class="avatar-uploader"
							:action="`short/video/info/uploadImage?videoType=1&appId=` + appId"
							:show-file-list="false"
							:on-change="(file, fileList) => handleUpimg('picUrl', file, fileList)"
							>
						<img v-if="ruleForm.picUrl" :src="ruleForm.picUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<p class="upimgId" v-if="ruleForm.picId">图片id：{{ruleForm.picId}}</p>
				</el-form-item>
				<el-form-item label="发行年份：" prop="issueYear">
					<el-input v-model="ruleForm.issueYear" placeholder="请输入发行年份"></el-input>
				</el-form-item>
				<el-form-item label="短剧更新状态：" prop="videoUpdateStatus">
					<el-select v-model="ruleForm.videoUpdateStatus" filterable clearable placeholder="请选择短剧更新状态">
						<el-option
								v-for="item in videoUpdateStatusOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="推荐语：" prop="recommendDescribe">
					<el-input v-model="ruleForm.recommendDescribe" maxlength="12" placeholder="请输入12个汉字以内的推荐语"></el-input>
				</el-form-item>
				<el-form-item label="短剧简介：" prop="introduce">
					<el-input type="textarea" v-model="ruleForm.introduce" placeholder="请输入200字以内短剧简介" :rows="5" maxlength="200" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="短剧类目标签：" prop="labelInfoList">
					<el-select v-model="ruleForm.labelInfoList" clearable multiple :multiple-limit="3" placeholder="请选择短剧类目标签，最多选择3个" @change="handleSelect">
						<el-option
								v-for="item in labelListOptions"
								:key="item.tagname"
								:label="item.tagname"
								:value="item.tagname">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="资质状态：" prop="qualifiedStatus">
					<el-select v-model="ruleForm.qualifiedStatus" filterable clearable placeholder="请选择资质状态" @change="changeQualified">
						<el-option
								v-for="item in qualifiedStatusOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
                <div v-if="ruleForm.videoRecord">
                    <el-alert
                            title="↓↓↓剧目审核备案相关↓↓↓"
                            type="info" :closable="false" style="margin: 40px 0 30px; font-weight: bold;color: #333;">
                    </el-alert>
                    <div v-if="ruleForm.qualifiedStatus != 1">
                        <el-form-item label="许可证号：" prop="videoRecord.licenseKey" :rules="rules.licenseKey">
                            <el-input v-model="ruleForm.videoRecord.licenseKey" placeholder="请输入许可证号"></el-input>
                        </el-form-item>
                        <el-form-item label="登记号：" prop="videoRecord.registerNo" :rules="rules.registerNo">
                            <el-input v-model="ruleForm.videoRecord.registerNo" placeholder="请输入登记号"></el-input>
                        </el-form-item>
                        <el-form-item label="普通备案号：" prop="videoRecord.generalRecordNo" :rules="rules.generalRecordNo">
                            <el-input v-model="ruleForm.videoRecord.generalRecordNo" placeholder="请输入普通备案号"></el-input>
                        </el-form-item>
                        <el-form-item label="重点备案号：" prop="videoRecord.importantRecordNo" :rules="rules.importantRecordNo">
                            <el-input v-model="ruleForm.videoRecord.importantRecordNo" placeholder="请输入重点备案号"></el-input>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-form-item label="短剧名称：" prop="videoRecord.svName" :rules="rules.svName">
                            <el-input v-model="ruleForm.videoRecord.svName" placeholder="请输入短剧名称"></el-input>
                        </el-form-item>
                        <el-form-item label="平均每集时长：" prop="videoRecord.duration" :rules="rules.duration">
                            <el-input type="number" v-model="ruleForm.videoRecord.duration" placeholder="单位分钟，请填写整数"></el-input>
                        </el-form-item>
                        <el-form-item label="总集数：" prop="videoRecord.sumEps" :rules="rules.sumEpsInfo">
                            <el-input type="number" v-model="ruleForm.videoRecord.sumEps" placeholder="请输入总集数"></el-input>
                        </el-form-item>
                        <el-form-item label="制作机构：" prop="videoRecord.organization" :rules="rules.organization">
                            <el-input v-model="ruleForm.videoRecord.organization" placeholder="请输入制作机构"></el-input>
                        </el-form-item>
                        <el-form-item label="导演：" prop="videoRecord.director" :rules="rules.director">
                            <ul class="ul-add-input">
                                <li v-for="(item, index) in directorList" :key="index">
                                    <el-input v-model="directorList[index]" placeholder="请输入导演" @blur="blurInput">
                                        <el-button slot="append" icon="el-icon-circle-plus" @click="addInput(directorList)"></el-button>
                                    </el-input>
                                    <!--<i class="icon-btn el-icon-circle-plus-outline" @click="addDirector"></i>-->
                                    <i class="icon-btn el-icon-delete danger-text" v-if="directorList.length > 1" @click="delInput(index, directorList)"></i>
                                </li>
                            </ul>
							<el-input v-model="ruleForm.videoRecord.director"  style="display: none"></el-input>
                        </el-form-item>
                        <el-form-item label="制作人：" prop="videoRecord.producer" :rules="rules.producer">
                            <ul class="ul-add-input">
                                <li v-for="(item, index) in producerList" :key="index">
                                    <el-input v-model="producerList[index]" placeholder="请输入制作人" @blur="blurInput">
                                        <el-button slot="append" icon="el-icon-circle-plus" @click="addInput(producerList)"></el-button>
                                    </el-input>
                                    <i class="icon-btn el-icon-delete danger-text" v-if="producerList.length > 1" @click="delInput(index, producerList)"></i>
                                </li>
                            </ul>
							<el-input v-model="ruleForm.videoRecord.producer"  style="display: none"></el-input>
                        </el-form-item>
                        <el-form-item label="编剧：" prop="videoRecord.dramatist" :rules="rules.dramatist">
                            <ul class="ul-add-input">
                                <li v-for="(item, index) in dramatistList" :key="index">
                                    <el-input v-model="dramatistList[index]" placeholder="请输入编剧" @blur="blurInput">
                                        <el-button slot="append" icon="el-icon-circle-plus" @click="addInput(dramatistList)"></el-button>
                                    </el-input>
                                    <i class="icon-btn el-icon-delete danger-text" v-if="dramatistList.length > 1" @click="delInput(index, dramatistList)"></i>
                                </li>
                            </ul>
							<el-input v-model="ruleForm.videoRecord.dramatist"  style="display: none"></el-input>
                        </el-form-item>
                        <el-form-item label="演员：" prop="videoRecord.performer" :rules="rules.performer">
                            <ul class="ul-add-input">
                                <li v-for="(item, index) in performerList" :key="index">
                                    <el-input v-model="performerList[index]" placeholder="请输入演员" @blur="blurInput">
                                        <el-button slot="append" icon="el-icon-circle-plus" @click="addInput(performerList)"></el-button>
                                    </el-input>
                                    <i class="icon-btn el-icon-delete danger-text" v-if="performerList.length > 1" @click="delInput(index, performerList)"></i>
                                </li>
                            </ul>
							<el-input v-model="ruleForm.videoRecord.performer"  style="display: none"></el-input>
                        </el-form-item>
                        <el-form-item label="内容梗概：" prop="videoRecord.contentOutline" :rules="rules.contentOutline">
                            <el-input type="textarea" v-model="ruleForm.videoRecord.contentOutline" placeholder="请输入200字以内短剧简介" :rows="5" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="成本配置比例情况：" prop="videoRecord.costPicUrl" :rules="rules.costPicUrl">
                            <div class="upload-row">
                                <div class="img-col">
                                    <img v-if="ruleForm.videoRecord.costPicUrl" :src="ruleForm.videoRecord.costPicUrl" class="avatar">
                                    <div v-else class="icon-upload"><i class="el-icon-plus"></i></div>
                                </div>
                                <div class="upload-col">
                                    <el-upload
                                            class="upload-demo"
                                            :action="`short/video/info/uploadImage?videoType=1&appId=` + appId"
                                            :show-file-list="false"
                                            :on-change="(file, fileList) => handleUpimg('costPicUrl', file, fileList)">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip" @click="downTemplate('https://bytedance.larkoffice.com/file/OZADbVvvwoY2VXxV3oQcYKFLnjb')">点此下载成本配置比例情况模板 <a class="primary-text text-underline" style="margin-left: 10px">下载模板</a></div>
                                    </el-upload>
                                </div>
                            </div>
                            <p class="upimgId" v-if="ruleForm.videoRecord.costPicId">图片id：{{ruleForm.videoRecord.costPicId}}</p>
                        </el-form-item>
                        <el-form-item label="承诺书：" prop="videoRecord.promisePicUrl" :rules="rules.promisePicUrl">
                            <div class="upload-row">
                                <div class="img-col">
                                    <img v-if="ruleForm.videoRecord.promisePicUrl" :src="ruleForm.videoRecord.promisePicUrl" class="avatar">
                                    <div v-else class="icon-upload"><i class="el-icon-plus"></i></div>
                                </div>
                                <div class="upload-col">
                                    <el-upload
                                            class="upload-demo"
                                            :action="`short/video/info/uploadImage?videoType=1&appId=` + appId"
                                            :show-file-list="false"
                                            :on-change="(file, fileList) => handleUpimg('promisePicUrl', file, fileList)">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip" @click="downTemplate('https://bytedance.larkoffice.com/file/B56YbNcJEozdNWxOEMncYhEmnSe')">点此下载承诺书模板 <a class="primary-text text-underline" style="margin-left: 10px">下载模板</a></div>
                                    </el-upload>
                                </div>
                            </div>
                            <p class="upimgId" v-if="ruleForm.videoRecord.promisePicId">图片id：{{ruleForm.videoRecord.promisePicId}}</p>
                        </el-form-item>
                        <el-form-item label="制作成本：" prop="videoRecord.costType" :rules="rules.costType">
                            <el-select v-model="ruleForm.videoRecord.costType" filterable clearable placeholder="请选择制作成本">
                                <el-option
                                        v-for="item in costTypeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备案号类型：" prop="videoRecord.recordType" :rules="rules.recordType">
                            <el-select v-model="ruleForm.videoRecord.recordType" filterable clearable placeholder="请选择公众号">
                                <el-option
                                        v-for="item in recordTypeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="广电备案号：" prop="videoRecord.svaRecordNo" :rules="rules.svaRecordNo">
                            <el-input v-model="ruleForm.videoRecord.svaRecordNo" placeholder="请输入广告备案号，无备案号不用填写"></el-input>
                        </el-form-item>
                    </div>
                </div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<app-table :visible.sync="isShowDialogApp" :selectApp="selectApp"  @appSure="appSure" @cancelDialogApp="cancelDialogApp"></app-table>
	</div>
</template>
<script>
    import AppTable from '@/components/AppTable';
    import { listVideoMedia, details, addVideoMedia, del, listLabel, addVid, addVideo, createVideo, addEpisodeId, addVideoAuth, getVerifyStatus, submitReview, upOrDownVideo} from "@/api/dysvzk/dymedia/add";
    // import ElTableBody from "element-ui/packages/table/src/table-body";
    // import ElTableBody from "element-ui/packages/table/src/table-body";
    // var directorListValue = []
    // var producerListValue = []
    // var dramatistListValue = []
    // var performerListValue = []
    export default {
        components: {
            AppTable
        },
    data() {
        var validateDuration = (rule, value, callback) => {
            if (!(/(^[1-9]\d*$)/.test(value))) {
                return callback(new Error('输入的不是正整数'));
            } else {
                callback();
            }
        };
        var validateNum = (rule, value, callback) => {
            if (!(/(^[1-9]\d*$)/.test(value))) {
                return callback(new Error('集数应为正整数'));
            } else {
                callback();
            }
        };
		return {
            appId:localStorage.getItem('appId'),
            loading: false,
			formInline: {
                albumId: '',
                title: '',
                isVerify: '',
                rackStatus: ''
			},
            isVerifyOptions: [
                {
                    value: 0,
                    label: '未审核'
                },
                {
                    value: 1,
                    label: '审核中'
                },
                {
                    value: 2,
                    label: '已审核'
                },
                {
                    value: 3,
                    label: '审核不通过'
                }
            ],
            rackStatusOptions: [
                {
                    value: 0,
                    label: '未上线'
                },
                {
                    value: 1,
                    label: '已上线'
                }
            ],
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: []
			},
            visiblePopover: false,
			currentPage: 1,
            dialogInfoVisible: false, // 详情弹框
			dialogTitle: '添加',
            dialogFormVisible: false, // 编辑弹框
            updateType: 'add',
            qualifiedStatusOptions: [ // 资质状态
                {
                    value: 1,
                    label: '未报审'
                },
                {
                    value: 2,
                    label: '报审通过'
                },
                {
                    value: 3,
                    label: '报审不通过'
                },
                {
                    value: 4,
                    label: '不建议报审'
                }
            ],
            videoUpdateStatusOptions: [ // 更新状态
                {
                    value: 1,
                    label: '已完成'
                }
            ],
            costTypeOptions: [ // 制作成本
                {
                    value: 1,
                    label: '30万以下'
                },
                {
                    value: 2,
                    label: '30-100万'
                },
                {
                    value: 3,
                    label: '100万以上'
                }
            ],
            recordTypeOptions: [
                {
                    value: 1,
                    label: '普通备案号'
                },
                {
                    value: 2,
                    label: '重点备案号'
                }
            ],
            labelListOptions: [],
            labelList: [],
            directorList: [''], // 导演
            producerList: [''], // 制作人
            dramatistList: [''], // 编剧
            performerList: [''], // 演员
            videoRecordFlag: true,
            ruleForm: {
                updateType: '',
				appid: '',
                appidName: '',
                videoUpdateStatus: '',
                id: '',
                introduce: '',
                issueYear: '',
                labelInfoList: [],
                picId: '',
                picUrl: '',
                qualifiedStatus: '',
                recommendDescribe: '',
                sumEps: '',
                title: '',
                verifyMsg: '',
                verifyNumber: '',
                videoAbility: '',
                videoRecord: {
                    contentOutline: '',
                    costPicId: '',
                    costPicUrl: '',
                    director: '',
                    dramatist: '',
                    duration: '',
                    costType: '',
                    generalRecordNo: '',
                    id: '',
                    importantRecordNo: '',
                    licenseKey: '',
                    organization: '',
                    performer: '',
                    producer: '',
                    promisePicId: '',
                    promisePicUrl: '',
                    recordType: '',
                    registerNo: '',
                    sumEps: '',
                    svName: '',
                    svaRecordNo: '',
                }
            },
            rules: {
                appid: [
                    {required: true, message: '请选择小程序', trigger: 'change'}
                ],
                licenseKey: [
                    {required: true, message: '请输入许可证号', trigger: 'blur'}
                ],
                registerNo: [
                    {required: true, message: '请输入登记号', trigger: 'blur'}
                ],
                generalRecordNo: [
                    {required: true, message: '请输入普通备案号', trigger: 'blur'}
                ],
                importantRecordNo: [
                    {required: true, message: '请输入重点备案号', trigger: 'blur'}
                ],
                title: [
                    {required: true, message: '请输入短剧名称', trigger: 'blur'}
                ],
                sumEps: [
                    {required: true, message: '请输入总集数', trigger: 'blur'},
                    { validator: validateNum, trigger: 'blur' }
                ],
                sumEpsInfo: [
                    {required: true, message: '请输入总集数', trigger: 'blur'},
                    { validator: validateNum, trigger: 'blur' }
                ],
                picUrl: [
                    {required: true, message: '请上传封面图', trigger: 'blur'}
                ],
                issueYear: [
                    {required: true, message: '请输入发行年份', trigger: 'blur'}
                ],
                videoUpdateStatus: [
                    {required: true, message: '请选择短剧更新状态', trigger: 'change'}
                ],
                recommendDescribe: [
                    { required: true, message: '请输入推荐语', trigger: 'blur' }
                ],
                introduce: [
                    { required: true, message: '请输入短剧简介', trigger: 'blur' }
                ],
                labelInfoList: [
                    { required: true, message: '请选择短剧类目标签', trigger: 'change' }
                ],
                qualifiedStatus: [
                    { required: true, message: '请选择资质状态', trigger: 'change' }
                ],
                svName: [
                    { required: true, message: '请输入短剧名称', trigger: 'blur' }
                ],
                duration: [
                    { required: true, message: '请输入平均每集时长', trigger: 'blur' },
                    { validator: validateDuration, trigger: 'blur' }
                ],
                organization: [
                    { required: true, message: '请输入制作机构', trigger: 'blur' }
                ],
                director: [
                    { required: true, message: '请输入导演', trigger: 'blur' }
                ],
                producer: [
                    { required: true, message: '请输入制作人', trigger: 'blur' }
                ],
                dramatist: [
                    { required: true, message: '请输入编剧', trigger: 'blur' }
                ],
                performer: [
                    { required: true, message: '请输入演员', trigger: 'blur' }
                ],
                contentOutline: [
                    { required: true, message: '请输入内容梗概', trigger: 'blur' }
                ],
                costPicUrl: [
                    { required: true, message: '请上传图片', trigger: 'change' }
                ],
                promisePicUrl: [
                    { required: true, message: '请上传图片', trigger: 'change' }
                ],
                costType: [
                    { required: true, message: '请选择制作成本', trigger: 'change' }
                ],
                recordType: [
                    { required: true, message: '请选择备案号类型', trigger: 'change' }
                ]
                // svaRecordNo: [
                //     { required: true, message: '请输入广电备案号', trigger: 'blur' }
                // ]
            },
            isShowDialogApp: false,
            selectApp: {}
		}
	},
	computed: {},
	watch: {
	},
	mounted: function() {
		this.getTableData()
        this.getLabelList()
	},
	methods: {
        // 添加
        addInput(list) {
            list.push('')
        },
        blurInput () {
			this.ruleForm.videoRecord.director = this.directorList.toString()
			this.ruleForm.videoRecord.producer = this.producerList.toString()
			this.ruleForm.videoRecord.dramatist = this.dramatistList.toString()
			this.ruleForm.videoRecord.performer= this.performerList.toString()
			console.log(this.ruleForm.videoRecord)
		},
        // 删除
        delInput(index, list) {
            list.splice(index, 1)
            this.ruleForm.videoRecord.director = this.directorList.toString()
            this.ruleForm.videoRecord.producer = this.producerList.toString()
            this.ruleForm.videoRecord.dramatist = this.dramatistList.toString()
            this.ruleForm.videoRecord.performer= this.performerList.toString()
            console.log(this.ruleForm.videoRecord)
        },
        // 关闭选小程序弹窗
        cancelDialogApp(data) {
            console.log('cancel')
            this.isShowDialogApp = data
        },
        // 确定小程序
        appSure(data) {
            this.ruleForm.appidName = data.name
            this.ruleForm.appid = data.appId
            this.selectApp = data
        },
        // 删除所选小程序
        handleCloseTagApp(tag){
            console.log(tag)
            this.ruleForm.appidName = ''
            this.ruleForm.appid = ''
            this.selectApp = {}
        },
		search () {
			this.currentPage = 1
			this.getTableData()
		},
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableData()
            // console.log(formName)
            // this.$refs[formName].resetFields()
            // this.getTableData()
        },
        downTemplate(url) {
			window.open(url)
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
        // pageSize切换
        handleSizeChange (val) {
            this.tableData.pageSize  = val
            this.currentPage = 1
            this.getTableData()
        },
		// 标签类目
        handleSelect(val) {
			console.log(val.toString())  
		},
		// 资质切换清除验证
        changeQualified(val) {
			if (val == 1) {
                this.$refs['ruleForm'].clearValidate(['licenseKey', 'registerNo', 'generalRecordNo', 'importantRecordNo'])
			} else {
                this.$refs['ruleForm'].clearValidate(['svName', 'duration', 'sumEpsInfo', 'organization', 'director', 'producer', 'dramatist', 'performer', 'contentOutline', 'costPicUrl', 'promisePicUrl', 'costType', 'recordType', 'svaRecordNo'])
			}
		},
        handleLook(id) {
            console.log(id)
            this.dialogInfoVisible = true
            this.getDetails(id, 'look')
        },
		// 添加表格
		addData()  {
			this.dialogTitle = '添加'
            if (this.$refs['ruleForm'] !== undefined) {
                this.$refs['ruleForm'].resetFields()
            }
            this.ruleForm = {
                updateType: '',
                appid: '',
                appidName: '',
                videoUpdateStatus: '',
                id: '',
                introduce: '',
                issueYear: '',
                labelInfoList: [],
                picId: '',
                picUrl: '',
                qualifiedStatus: '',
                recommendDescribe: '',
                sumEps: '',
                title: '',
                verifyMsg: '',
                verifyNumber: '',
                videoAbility: '',
                videoRecord: {
                    contentOutline: '',
                    costPicId: '',
                    costPicUrl: '',
                    director: '',
                    dramatist: '',
                    duration: '',
                    costType: '',
                    generalRecordNo: '',
                    id: '',
                    importantRecordNo: '',
                    licenseKey: '',
                    organization: '',
                    performer: '',
                    producer: '',
                    promisePicId: '',
                    promisePicUrl: '',
                    recordType: '',
                    registerNo: '',
                    sumEps: '',
                    svName: '',
                    svaRecordNo: '',
                }
            },
            this.selectApp = {}
            this.directorList = ['']
            this.performerList = ['']
            this.producerList = ['']
            this.dramatistList = ['']
            // directorListValue = []
            // producerListValue = []
            // dramatistListValue = []
            // performerListValue = []
            this.videoRecordFlag = true
            this.dialogFormVisible = true
		},
        // 删除
        handleDelete(id) {
            console.log(id)
            del({
                videoId: id
            }).then(response => {
                if (response.data.head.flag === 0) {
                    if (this.tableData.result.length === 1 && this.currentPage > 1) {
                        this.currentPage =  this.currentPage - 1
                    }
                    this.$refs[id].doClose()
                    this.getTableData()
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        },
		// 编辑
        handleEdit(id) {
			console.log(id)
            if (this.$refs['ruleForm'] !== undefined) {
                this.$refs['ruleForm'].resetFields()
            }
            this.dialogTitle = '编辑'
            this.dialogFormVisible = true
            this.getDetails(id, 'edit')
		},
		// 获取详情
		getDetails(id, text){
            details({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    let formData = response.data.content
                    this.ruleForm = response.data.content
                    if (text == 'edit') {
                        this.ruleForm.updateType = 'edit'
                        // this.ruleForm.addTime = null
						// this.ruleForm.videoRecord.addTime = null
                        // this.ruleForm.labelInfo = formData.labelInfo.split(',')
						if (response.data.content.videoRecord) {
                            this.directorList = formData.videoRecord.director.split(',')
                            this.performerList = formData.videoRecord.performer.split(',')
                            this.producerList = formData.videoRecord.producer.split(',')
                            this.dramatistList = formData.videoRecord.dramatist.split(',')
						} else {
                           this.ruleForm.videoRecord = {
                                contentOutline: '',
                                    costPicId: '',
                                    costPicUrl: '',
                                    director: '',
                                    dramatist: '',
                                    duration: '',
                                    costType: '',
                                    generalRecordNo: '',
                                    id: '',
                                    importantRecordNo: '',
                                    licenseKey: '',
                                    organization: '',
                                    performer: '',
                                    producer: '',
                                    promisePicId: '',
                                    promisePicUrl: '',
                                    recordType: '',
                                    registerNo: '',
                                    sumEps: '',
                                    svName: '',
                                    svaRecordNo: '',
                            }
						}
                    }
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
		},
        // 弹框确定
        editDialogSureBtn (formName) {
            this.ruleForm.labelInfo = JSON.stringify(this.ruleForm.labelInfoList)
            console.log(this.ruleForm)
            // this.ruleForm.labelInfo = this.ruleForm.labelInfo.toString()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm.updateType)
                    this.saveTableData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 保存编辑信息
        saveTableData () {
            addVideoMedia(this.ruleForm).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        },
		getLabelList() {
            listLabel({
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.labelListOptions = response.data.content.result
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
		},
        getTableData() {
            let json2 = {
                videoType: 1,
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            listVideoMedia(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        handleCommand(command, id) {
			console.log(this[command])
            if (typeof this[command] === 'function') {
                this[command]({
                    videoId: id,
                }).then(response => {
                    console.log(response)
                    if (response.data.head.flag === 0) {
                        this.getTableData()
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            }
		},
        // 创建短剧
        handleCreateVideo(id) {
            createVideo({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '创建成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        // 一键上传视频
        handleAddVideo(id) {
            this.loading = true
            addVideo({
                videoId: id,
            }).then(response => {
                this.loading = false
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
		// 编辑短剧
        handleAddEpisodeId(id) {
            addEpisodeId({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
		},
        // 短剧授权
        handleAddVideoAuth(id) {
            addVideoAuth({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '授权成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
		},
        // 送审查询
        handleSubmitReview(id) {
            submitReview({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '送审成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        // 一键上线
        handleUpOrDownVideo(id, rack) {
            upOrDownVideo({
                rackStatus: rack,
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '请求成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        // 审核查询
        handleGetVerifyStatus(id) {
            getVerifyStatus({
                videoId: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '查询成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
		// 一键上传vid
		handleAddVid(id) {
            this.loading = true
            addVid({
                videoId: id,
            }).then(response => {
                this.loading = false
                if (response.data.head.flag === 0) {
                    this.getTableData()
                    this.$message({
                        message: '填充成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
		},
        // 图片上传
        handleUpimg (text, file, fileList) {
            console.log(file, fileList);
            console.log(text);
            if (file.status === 'success') {
                if (file.response.head.flag === 0) {
                    if (text == 'picUrl' ) {
                        console.log(1);
                        this.ruleForm.picUrl = file.response.content.imgPath
                        this.ruleForm.picId = file.response.content.imgId
					} else if (text == 'costPicUrl') {
                        console.log(2);
                        this.ruleForm.videoRecord.costPicUrl = file.response.content.imgPath
                        this.ruleForm.videoRecord.costPicId = file.response.content.imgId
					} else if (text == 'promisePicUrl') {
                        console.log(3);
                        this.ruleForm.videoRecord.promisePicUrl = file.response.content.imgPath
                        this.ruleForm.videoRecord.promisePicId = file.response.content.imgId
					}
                    this.$notify({
                        title: '上传成功',
                        message: '上传成功',
                        type: 'success'
                    })
                    this.$refs['ruleForm'].clearValidate(text)
                } else {
                    this.$message.error(file.response.data.head.desc)
                }
            } else if (file.status === 'fail') {
                // console.log(file.status)
                this.$notify.error({
                    title: '上传失败',
                    message: '上传失败，请重新再传'
                })
                this.ruleForm.picUrl = ''
            }
        }
	}
}
</script>
